/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type appQuickbooks_viewer$ref: FragmentReference;
declare export opaque type appQuickbooks_viewer$fragmentType: appQuickbooks_viewer$ref;
export type appQuickbooks_viewer = {|
  +id: string,
  +company: ?{|
    +id: string,
    +quickbooksEnabled: ?boolean,
  |},
  +$refType: appQuickbooks_viewer$ref,
|};
export type appQuickbooks_viewer$data = appQuickbooks_viewer;
export type appQuickbooks_viewer$key = {
  +$data?: appQuickbooks_viewer$data,
  +$fragmentRefs: appQuickbooks_viewer$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appQuickbooks_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "quickbooksEnabled",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a6d5fdc38954f2c51843471ff2b2c5e1';

module.exports = node;
